import { useState } from 'react';
import { RadioTower } from 'lucide-react';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { SettingsPage } from './pages/SettingsPage';
import { useAuth } from './hooks/useAuth';

export function App() {
  const auth = useAuth();
  const [view, setView] = useState<'home' | 'settings'>('home');

  if (auth.status === 'checking') {
    return (
      <main className="app-shell auth-shell">
        <section className="hero-panel auth-panel loading-panel" aria-label="Loading SOS Signal">
          <span className="permission-icon danger">
            <RadioTower size={24} aria-hidden="true" />
          </span>
          <h1>SOS Signal</h1>
          <p>Checking private session...</p>
        </section>
      </main>
    );
  }

  if (auth.status !== 'authenticated' || !auth.username || !auth.token) {
    return <LoginPage authError={auth.error} onLogin={auth.login} />;
  }

  if (view === 'settings') {
    return (
      <SettingsPage
        username={auth.username}
        token={auth.token}
        onBack={() => setView('home')}
        onLogout={auth.logout}
      />
    );
  }

  return (
    <HomePage
      username={auth.username}
      token={auth.token}
      onLogout={auth.logout}
      onOpenSettings={() => setView('settings')}
    />
  );
}
